module.exports = __webpack_public_path__ + "static/media/nike-land-of-new-football.17551d0d.jpg";